import { metricColors } from "../../../components/custom/analytics/palettes";
import { type MetricConfig } from "../../merchandising/utils/metrics";

/** Metrics for the columns of AMC report CSVs. */
export const metrics: MetricConfig[] = [
  {
    id: "all_users_with_purchase",
    color: metricColors.metric1[0],
    accessor: (d) => d?.all_users_with_purchase ?? null,
    format: "number",
  },
  {
    id: "ntb_users",
    color: metricColors.metric1[0],
    accessor: (d) => d?.ntb_users ?? null,
    format: "number",
  },
  {
    id: "ntb_percentage",
    color: metricColors.metric1[0],
    accessor: (d) => (d?.ntb_percentage ? d.ntb_percentage / 100 : null),
    format: "percent",
  },
  {
    id: "gateway_asin_rank",
    color: metricColors.metric1[0],
    accessor: (d) => d?.gateway_asin_rank ?? null,
    format: "number",
  },
  {
    id: "distinct_user_count",
    color: metricColors.metric1[0],
    accessor: (d) => d?.distinct_user_count ?? null,
    format: "number",
  },
  {
    id: "customer_cnt",
    color: metricColors.metric1[0],
    accessor: (d) => d?.customer_cnt ?? null,
    format: "number",
  },
  {
    id: "units_sold",
    color: metricColors.metric1[0],
    accessor: (d) => d?.units_sold ?? null,
    format: "number",
  },
  {
    id: "ltv",
    color: metricColors.metric1[0],
    accessor: (d) => d?.ltv ?? null,
    format: "currency",
  },

  {
    id: "engagement_scope",
    color: metricColors.metric1[0],
    accessor: (d) => d?.engagement_scope ?? null,
    format: "text",
  },
  {
    id: "campaign",
    color: metricColors.metric1[0],
    accessor: (d) => d?.campaign ?? null,
    format: "text",
  },
  {
    id: "purchases",
    color: metricColors.metric1[0],
    accessor: (d) => d?.purchases ?? null,
    format: "number",
  },

  {
    id: "ad_product_type",
    color: metricColors.metric1[0],
    accessor: (d) => d?.ad_product_type ?? null,
    format: "text",
  },
  {
    id: "users_that_purchased",
    color: metricColors.metric1[0],
    accessor: (d) => d?.users_that_purchased ?? null,
    format: "number",
  },
  {
    id: "users_that_clicked",
    color: metricColors.metric1[0],
    accessor: (d) => d?.users_that_clicked ?? null,
    format: "number",
  },
  {
    id: "unique_reach",
    color: metricColors.metric1[0],
    accessor: (d) => d?.unique_reach ?? null,
    format: "number",
  },
  {
    id: "total_clicks",
    color: metricColors.metric1[0],
    accessor: (d) => d?.total_clicks ?? null,
    format: "number",
  },
  {
    id: "total_impressions",
    color: metricColors.metric1[0],
    accessor: (d) => d?.total_impressions ?? null,
    format: "number",
  },
  {
    id: "total_spend",
    color: metricColors.metric1[0],
    accessor: (d) => d?.total_spend ?? null,
    format: "currency",
  },
  {
    id: "total_product_sales",
    color: metricColors.metric1[0],
    accessor: (d) => d?.total_product_sales ?? null,
    format: "currency",
  },
  {
    id: "purchase_rate",
    color: metricColors.metric1[0],
    accessor: (d) => d?.purchase_rate ?? null,
    format: "percent",
  },
  {
    id: "sns_purchase_frequency",
    color: metricColors.metric1[0],
    accessor: (d) => d?.sns_purchase_frequency ?? null,
    format: "text",
  },
  {
    id: "total_sns_count",
    color: metricColors.metric1[0],
    accessor: (d) => d?.total_sns_count ?? null,
    format: "number",
  },
  {
    id: "percent_total_sns",
    color: metricColors.metric1[0],
    accessor: (d) => d?.percent_total_sns ?? null,
    format: "percent",
  },
  {
    id: "conversions",
    color: metricColors.metric1[0],
    accessor: (d) => d?.conversions ?? null,
    format: "number",
  },
  {
    id: "user_reach",
    color: metricColors.metric1[0],
    accessor: (d) => d?.user_reach ?? null,
    format: "number",
  },
  {
    id: "users_that_converted",
    color: metricColors.metric1[0],
    accessor: (d) => d?.users_that_converted ?? null,
    format: "number",
  },
  {
    id: "frequency_bucket",
    color: metricColors.metric1[0],
    accessor: (d) => d?.frequency_bucket ?? null,
    format: "number",
  },
  {
    id: "users_in_bucket",
    color: metricColors.metric1[0],
    accessor: (d) => d?.users_in_bucket ?? null,
    format: "number",
  },
  {
    id: "impressions_in_bucket",
    color: metricColors.metric1[0],
    accessor: (d) => d?.impressions_in_bucket ?? null,
    format: "number",
  },
  {
    id: "percent_of_total_users",
    color: metricColors.metric1[0],
    accessor: (d) => d?.percent_of_total_users ?? null,
    format: "percent",
  },
  {
    id: "lead_asin",
    color: metricColors.metric1[0],
    accessor: (d) => d?.lead_asin ?? null,
    format: "text",
  },
  {
    id: "lead_asin_purchases",
    color: metricColors.metric1[0],
    accessor: (d) => d?.lead_asin_purchases ?? null,
    format: "number",
  },
  {
    id: "dist_lead_asin_purchased_user_count",
    color: metricColors.metric1[0],
    accessor: (d) => d?.dist_lead_asin_purchased_user_count ?? null,
    format: "number",
  },
  {
    id: "overlap_asin",
    color: metricColors.metric1[0],
    accessor: (d) => d?.overlap_asin ?? null,
    format: "text",
  },
  {
    id: "dist_lead_and_overlap_asin_purchased_user_count",
    color: metricColors.metric1[0],
    accessor: (d) => d?.dist_lead_and_overlap_asin_purchased_user_count ?? null,
    format: "number",
  },
  {
    id: "user_overlap",
    color: metricColors.metric1[0],
    accessor: (d) => d?.user_overlap ?? null,
    format: "percent",
  },
  {
    id: "campaign_id_string",
    color: metricColors.metric1[0],
    accessor: (d) => d?.campaign_id_string ?? null,
    format: "text",
  },
  {
    id: "time_to_conversion",
    color: metricColors.metric1[0],
    accessor: (d) => d?.time_to_conversion ?? null,
    format: "text",
  },
  {
    id: "total_brand_purchases",
    color: metricColors.metric1[0],
    accessor: (d) => d?.total_brand_purchases ?? null,
    format: "number",
  },
  {
    id: "< 1 Min",
    color: metricColors.metric1[0],
    accessor: (d) => d["< 1 Min"] ?? 0,
    format: "number",
  },
  {
    id: "From 1min - 10min",
    color: metricColors.metric1[0],
    accessor: (d) => d["From 1min - 10min"] ?? 0,
    format: "number",
  },
  {
    id: "From 10min - 30min",
    color: metricColors.metric1[0],
    accessor: (d) => d["From 10min - 30min"] ?? 0,
    format: "number",
  },
  {
    id: "From 30min - 1h",
    color: metricColors.metric1[0],
    accessor: (d) => d["From 30min - 1h"] ?? 0,
    format: "number",
  },
  {
    id: "From 1h - 2h",
    color: metricColors.metric1[0],
    accessor: (d) => d["From 1h - 2h"] ?? 0,
    format: "number",
  },
  {
    id: "From 2h - 12h",
    color: metricColors.metric1[0],
    accessor: (d) => d["From 2h - 12h"] ?? 0,
    format: "number",
  },
  {
    id: "From 12h - 24h",
    color: metricColors.metric1[0],
    accessor: (d) => d["From 12h - 24h"] ?? 0,
    format: "number",
  },
  {
    id: "From 1 - 3 Days",
    color: metricColors.metric1[0],
    accessor: (d) => d["From 1 - 3 Days"] ?? 0,
    format: "number",
  },
  {
    id: "From 3 - 5 Days",
    color: metricColors.metric1[0],
    accessor: (d) => d["From 3 - 5 Days"] ?? 0,
    format: "number",
  },
  {
    id: "From 5 - 7 Days",
    color: metricColors.metric1[0],
    accessor: (d) => d["From 5 - 7 Days"] ?? 0,
    format: "number",
  },
  {
    id: "More than 7 Days",
    color: metricColors.metric1[0],
    accessor: (d) => d["More than 7 Days"] ?? 0,
    format: "number",
  },
  {
    id: "advertiser",
    color: metricColors.metric1[0],
    accessor: (d) => d?.advertiser ?? null,
    format: "text",
  },
  {
    id: "campaign_id",
    color: metricColors.metric1[0],
    accessor: (d) => d?.campaign_id ?? null,
    format: "text",
  },
  {
    id: "ntb_conversions",
    color: metricColors.metric1[0],
    accessor: (d) => d?.ntb_conversions ?? null,
    format: "number",
  },
  {
    id: "non_ntb_conversions",
    color: metricColors.metric1[0],
    accessor: (d) => d?.non_ntb_conversions ?? null,
    format: "number",
  },
  {
    id: "ntb_conversions_pct",
    color: metricColors.metric1[0],
    accessor: (d) => d?.ntb_conversions_pct ?? null,
    format: "percent",
  },
  {
    id: "ntb_units",
    color: metricColors.metric1[0],
    accessor: (d) => d?.ntb_units ?? null,
    format: "number",
  },
  {
    id: "non_ntb_units",
    color: metricColors.metric1[0],
    accessor: (d) => d?.non_ntb_units ?? null,
    format: "number",
  },
  {
    id: "ntb_units_pct",
    color: metricColors.metric1[0],
    accessor: (d) => d?.ntb_units_pct ?? null,
    format: "percent",
  },
  {
    id: "ntb_product_sales",
    color: metricColors.metric1[0],
    accessor: (d) => d?.ntb_product_sales ?? null,
    format: "number",
  },
  {
    id: "non_ntb_product_sales",
    color: metricColors.metric1[0],
    accessor: (d) => d?.non_ntb_product_sales ?? null,
    format: "number",
  },
  {
    id: "ntb_product_sales_pct",
    color: metricColors.metric1[0],
    accessor: (d) => d?.ntb_product_sales_pct ?? null,
    format: "percent",
  },

  // AMC CSVs name these fields differently from the ads/DSP stats endpoints and carry no
  // previous-period values, so the registry's own metrics would read the wrong field or show a
  // comparison of zero.
  { id: "amc_impressions", accessor: (d) => d?.impressions ?? null, format: "number", decimalPlaces: 0 },
  { id: "amc_clicks", accessor: (d) => d?.clicks ?? null, format: "number", decimalPlaces: 0 },
  { id: "amc_total_purchases", accessor: (d) => d?.total_purchases ?? null, format: "number" },
  { id: "amc_total_units_sold", accessor: (d) => d?.total_units_sold ?? null, format: "number" },
  { id: "amc_detail_page_views", accessor: (d) => d?.dsp_total_detail_page_views ?? null, format: "number" },
  { id: "amc_add_to_cart", accessor: (d) => d?.dsp_total_add_to_cart ?? null, format: "number" },
  { id: "amc_sales", accessor: (d) => d?.sales ?? null, format: "currency", decimalPlaces: 2 },
  { id: "amc_ad_sales", accessor: (d) => d?.ad_sales ?? null, format: "currency", decimalPlaces: 2 },
  {
    id: "amc_ad_spend",
    accessor: (d) => d?.ad_spend ?? null,
    format: "currency",
    decimalPlaces: 2,
    compareHighlight: "neutral",
  },
  {
    id: "amc_cpc",
    accessor: (d) => d?.cost_per_click ?? null,
    format: "currency",
    decimalPlaces: 2,
    lower: true,
    compareHighlight: "negativeIsGood",
  },
  { id: "amc_roas", accessor: (d) => d?.roas ?? null, format: "number", decimalPlaces: 1 },
  {
    id: "amc_acos",
    accessor: (d) => d?.acos ?? null,
    format: "percent",
    decimalPlaces: 1,
    lower: true,
    compareHighlight: "negativeIsGood",
  },
  { id: "amc_ctr", accessor: (d) => d?.ctr ?? null, format: "percent", decimalPlaces: 2 },
  { id: "amc_conversion_rate", accessor: (d) => d?.conv_rate ?? null, format: "percent", decimalPlaces: 2 },
];
